import styled from '@emotion/styled';
import { Row } from 'antd';
import React from 'react';
import { useSelector } from 'react-redux';

import { getUserCustomBranding } from 'modules/users/selectors/currentUser';

import * as stylesHeader from './Header.module.less';

const Label = styled.img`
  height: 24px;
`;
const CustomLogos = () => {
  const { logoUrl, webLabelUrl, name } = useSelector(getUserCustomBranding);
  return (
    <Row justify="start" align="middle" type="flex">
      <img src={logoUrl} alt={name} className={stylesHeader['header-logo__ico']} />
      <Label src={webLabelUrl} alt={name} className={stylesHeader['header-logo__label']} />
    </Row>
  );
};
export default CustomLogos;
